import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export const PublicMobileShell = ({ children }) => (
  <div className="min-h-screen bg-[#faf7f0] flex flex-col">
    <header className="sticky top-0 z-50 bg-primary text-white shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src="https://doberpogled.app/dober-pogled-logo.png" alt="Dober Pogled" className="w-11 h-11 rounded-full ring-2 ring-white/30 bg-white p-0.5" />
          <span className="font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Dober pogled</span>
        </Link>
        <div className="flex items-center gap-2">
          <Link to="/aplikacija"><Button variant="ghost" size="sm" className="text-white hover:bg-white/15 hover:text-white hidden sm:inline-flex" data-testid="nav-mobile-app">Aplikacija</Button></Link>
          <Link to="/login"><Button variant="ghost" size="sm" className="text-white hover:bg-white/15 hover:text-white" data-testid="nav-login-public">Prijava</Button></Link>
        </div>
      </div>
    </header>

    <main className="flex-1">{children}</main>

    <footer className="border-t border-primary/10 mt-12">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-slate-700">
        <div className="flex items-center gap-2">
          <img src="https://doberpogled.app/dober-pogled-logo.png" alt="" className="w-6 h-6 rounded-full" />
          <span>© 2026 Dober Pogled</span>
        </div>
        <div className="flex flex-wrap gap-4 items-center justify-center">
          <Link to="/aplikacija" className="hover:text-primary" data-testid="footer-aplikacija">Mobilna aplikacija</Link>
          <Link to="/podpora" className="hover:text-primary" data-testid="footer-podpora">Podpora</Link>
          <Link to="/zasebnost" className="hover:text-primary" data-testid="footer-zasebnost">Zasebnost</Link>
          <a href="mailto:info@doberpogled.app" className="hover:text-primary">info@doberpogled.app</a>
        </div>
      </div>
    </footer>
  </div>
);
